__turbopack_context__.v({
  "container": "tk22KW_container",
  "content": "tk22KW_content",
  "description": "tk22KW_description",
  "dragOver": "tk22KW_dragOver",
  "errorMessage": "tk22KW_errorMessage",
  "fileInfo": "tk22KW_fileInfo",
  "fileItem": "tk22KW_fileItem",
  "fileList": "tk22KW_fileList",
  "fileName": "tk22KW_fileName",
  "fileSize": "tk22KW_fileSize",
  "hiddenInput": "tk22KW_hiddenInput",
  "icon": "tk22KW_icon",
  "iconWrapper": "tk22KW_iconWrapper",
  "playIcon": "tk22KW_playIcon",
  "removeButton": "tk22KW_removeButton",
  "removeButtonOverlay": "tk22KW_removeButtonOverlay",
  "title": "tk22KW_title",
  "uploadButton": "tk22KW_uploadButton",
  "videoOverlay": "tk22KW_videoOverlay",
  "videoPreview": "tk22KW_videoPreview",
  "videoPreviewContainer": "tk22KW_videoPreviewContainer",
  "withPreview": "tk22KW_withPreview",
});
